export enum SubscriptionIdEnum {
  Monthly = 'com.syntho.subscription.monthly',
  Yearly = 'com.syntho.subscription.yearly',
}

export const SUBSCRIPTION_IDS = [
  SubscriptionIdEnum.Monthly,
  SubscriptionIdEnum.Yearly,
];

export enum TariffPlanCodeEnum {
  Trial = 10,
  Monthly = 30,
  Yearly = 40,
  Quarterly = 60,
}

export const SUBSCRIPTION_ID_BY_TARIFF_CODE = {
  [TariffPlanCodeEnum.Trial]: SubscriptionIdEnum.Monthly,
  [TariffPlanCodeEnum.Monthly]: SubscriptionIdEnum.Monthly,
  [TariffPlanCodeEnum.Quarterly]: SubscriptionIdEnum.Monthly,
  [TariffPlanCodeEnum.Yearly]: SubscriptionIdEnum.Yearly,
};

export const TARIFF_CODE_BY_SUBSCRIPTION_ID = {
  [SubscriptionIdEnum.Monthly]: TariffPlanCodeEnum.Trial,
  // [SubscriptionIdEnum.Monthly]: TariffPlanCodeEnum.Monthly,
  // [SubscriptionIdEnum.Monthly]: TariffPlanCodeEnum.Quarterly,
  [SubscriptionIdEnum.Yearly]: TariffPlanCodeEnum.Yearly,
};

export enum PaymentMethodEnum {
  Stripe = 0,
  ApplePay = 1,
  GooglePay = 2,
}

export enum TariffPlanStatusEnum {
  Active = 0,
  Inactive = 1,
  Canceled = 2,
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const subscriptionStoreURLs = {
  APPLE_APP_STORE: 'https://apps.apple.com/account/subscriptions',
  GOOGLE_PLAY_STORE:
    'https://play.google.com/store/account/subscriptions',
};

export enum ConfirmPaymentTypeEnum {
  Method = 0,
  Subscription = 1,
  Credits = 2,
}

export enum PaymentMethodTypeEnum {
  Card = 0,
  PayPal = 1,
  Link = 2,
}

export enum PaymentMethodWalletEnum {
  ApplePay = 0,
  GooglePay = 1,
}

export const PAYMENT_METHOD_TYPES = ['card', 'paypal', 'link'];
